module.exports = __webpack_public_path__ + "static/media/dfn.442872b9.svg";